export default __webpack_public_path__ + "static/media/mendi-logo-black.029d7eaf.png";